import { userService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationResetPasswordByDefaultUser() {
	return useMutation({
		mutationFn: ({ userId }: { userId: number }) => userService.resetPasswordByDefaultUser(userId)
	});
}
